export default {
    txt_welcome: 'Chào',
    txt_dataover: 'Tổng quan dữ liệu',
    txt_chance: 'Cơ hội',
    txt_device: 'Thiết bị',
    txt_chinese: '中文-Chinese',
    txt_english: '英文-English',
    txt_malay: '马来语-Malay',
    txt_reports: 'Hồ sơ phát hiện',
    txt_setting: 'Thiết lập',
    txt_dymanager: 'Quản lý bán hàng',
    txt_account: 'ID tài khoản.',
    txt_userstatus: 'Danh tính người dùng',
    txt_name: 'Tên',
    txt_contactway: 'Thông tin liên lạc',
    txt_accountsafe: 'Tài khoản bảo mật',
    txt_basicinfo: 'Thông tin cơ bản',
    txt_updatepassword: 'Thay đổi mật khẩu',
    txt_storeinfomation: 'Lưu trữ thông tin',
    txt_storename: 'Tên cửa hàng',
    txt_storephone: 'Điện thoại cửa hàng',
    txt_storeaddress: 'Địa chỉ cửa hàng',
    txt_AppInfomation: 'Thông tin ứng dụng',
    txt_currentversion: 'Phiên bản hiện tại',
    txt_software: 'Cập nhật phần mềm',
    txt_loginout: 'Thoát khỏi đăng nhập',
    txt_updatelanguage: 'Thiết lập ngôn ngữ',
    txt_updateto: 'Cập nhật đến',
    txt_zwgx: 'Không cập nhật',
    txt_dz: 'DianChang',
    txt_sh: 'ShangHu',
    txt_dy: 'Người bán hàng',
    txt_bdsj: 'Ràng buộc điện thoại di động',
    txt_shxx: 'Thông tin thương mại',
    txt_shname: 'Tên thương mại',
    txt_ssmd: 'Cửa hàng thuộc về',
    txt_bdsb: 'Thiết bị bị ràng buộc',
    txt_mendian: 'Cửa hàng',


    //数据总览模块
    txt_sTime: 'Chọn thời gian truy vấn',
    txt_car_check: 'Kiểm tra tỷ lệ',
    txt_findchance: 'Khám phá những cơ hội',
    txt_trackchace: 'Cơ hội theo dõi',
    txt_transform: 'Tỷ lệ biến đổi',
    txt_TotalData: 'Dữ liệu tổng quát',
    txt_xxsj: 'Dữ liệu chi tiết',
    txt_zhsj: 'Để biến đổi dữ liệu',
    txt_TireWear: 'Lốp xe mòn',
    txt_DataHopper: 'Kênh dữ liệu',
    txt_jdcc: 'Vào cửa hàng',
    txt_CheckCar: 'Kiểm tra số',
    txt_ChanceNum: 'Số cơ hội',
    txt_TrackNum: 'Theo dõi số',
    txt_TranseformNum: 'Chuyển đổi số',
    txt_UnTrack: 'Không theo dõi',
    txt_l: 'Chiếc xe',
    txt_Time: 'Thời gian',
    txt_Device: 'Thiết bị',
    txt_car_plate: 'Bảng số xe',
    txt_Wear: 'Bị mòn',
    txt_Pwear: 'Lệch quỹ xay',
    txt_NoData: 'Không có dữ liệu',
    txt_GoodState: 'Trạng thái tốt',
    txt_Border: 'Tình trạng biên giới',
    txt_replace: 'Ngay lập tức thay thế',
    txt_Total_Check: 'Phát hiện tổng số xe',
    txt_pmqk: 'Trường hợp mặc',
    txt_LightWear: 'Nhẹ hơn mài',
    txt_GraveWear: 'Nghiêm trọng mài',
    txt_hwtj: 'Sự thay đổi số',
    txt_wxhw: 'Không cần phải thay đổi',
    txt_xyhw: 'Cần phải thay đổi',
    txt_jcxq: 'Kiểm tra chi tiết',
    txt_zhxq: 'Chuyển đổi chi tiết',
    txt_cc: 'Xe',
    txt_bfb: '%',
    txt_ltxs: 'Lốp xe bán hàng',
    txt_sldw: 'Bốn bánh định vị',
    txt_ddlph: 'Sự cân bằng',
    txt_dphhh: 'Sự cân bằng',
    txt_qt: 'Những người khác',
    txt_zhqs: 'Biến đổi xu hướng',
    txt_ltxl: 'Bán lốp xe',
    txt_ltfw: 'Dịch vụ lốp xe',
    txt_ckxq: 'Xem chi tiết',
    txt_jt: 'Hôm nay',
    txt_zt: 'Hôm qua',
    txt_bz: 'Tuần này',
    txt_by: 'Tháng',
    txt_sy: 'Tháng trước',
    txt_jn: 'Năm nay',
    txt_zhcl: 'Chuyển đổi phương tiện',
    txt_zhl: 'Tỷ lệ biến đổi',
    txt_bfb: '%',
    txt_abjx: 'Sự phân phối theo số lốp xe trong tình trạng biên giới',
    txt_aljg: 'Nhấn ngay lập tức để thay thế sự phân bố số lốp xe',
    txt_qwpm: 'Theo phân phối số lốp xe nhẹ xuống',
    txt_ayzp: 'Theo sự phân bố số lốp xe bị xay nghiêm trọng',
    txt_lingt: '0 lốp',
    txt_yt: '1 lốp',
    txt_et: '2 lốp',
    txt_st: '3 lốp',
    txt_ft: '4 lốp',

    //机会
    txt_xsjh: 'Cơ hội bán hàng',
    txt_gzz: 'Theo dõi',
    txt_clwb: 'Xử lý xong rồi.',
    txt_ckbg: 'Xem báo cáo',
    txt_yxs: 'Tất cả các dữ liệu đã được hiển thị',
    txt_zhuiz: 'Theo dõi',
    txt_tix: 'Nhắc nhở',
    txt_chuli: 'Xử lý',
    txt_yzh: 'Đã được biến đổi',
    txt_wzh: 'Không được biến đổi',
    txt_gzsmts: '{0} kiểm tra vấn đề, dự kiến {1} sửa chữa cửa hàng',
    txt_czbty: 'Chủ sở hữu không đồng ý',
    txt_yyx: 'Có ý định',
    txt_ltyg: 'Lốp xe 1',
    txt_ltkg: 'Lốp xe 2',
    txt_ltsang: 'Lốp xe 3',
    txt_ltsig: 'Lốp xe 4',
    txt_jhcl: 'Cơ hội để đối phó với',
    txt_jhztai: 'Tình trạng cơ hội',
    txt_crquy: '责任区域',
    txt_chuliry: 'Người quản lý',
    txt_chulijg: 'Xử lý kết quả',
    txt_zhuanhuanr: 'Biến đổi nội dung',
    txt_zhuanhuaje: 'Chuyển đổi số tiền',
    txt_zhuanhuasj: 'Chuyển đổi thời gian',
    txt_zhuanhuayx: 'Chuyển đổi ý định',
    txt_xuanzesj: 'Chọn thời gian',
    txt_tsdatawk: 'Không thể lưu dữ liệu khi tình trạng cơ hội là trống',
    txt_qtxzhsj: 'Hãy điền thời gian dự kiến vào mục "ý định"',
    txt_qtxzhnr: 'Xin vui lòng điền vào nội dung chuyển đổi',
    txt_qtxzhsj: 'Vui lòng điền vào thời gian chuyển đổi',
    txt_sbts: 'Dữ liệu bị lỗi, hãy kiểm tra mạng',


    //设备
    txt_sbgl: 'Quản lý thiết bị',
    txt_tj: 'Thêm',
    txt_gdssb: 'Tất cả các thiết bị',
    txt_sbbh: 'Số thiết bị',
    txt_gjbb: 'Phiên bản phần mềm',
    txt_tjsj: 'Thêm thời gian',
    txt_zdgx: 'Tự động cập nhật',
    txt_gxgj: 'Cập nhật phần mềm',
    txt_jieb: 'Giải trói',
    txt_sbtsxx: 'Có một phiên bản mới cho phần mềm thiết bị, nhấn nút cập nhật phần mềm để cập nhật',
    txt_wjh: 'Bất hoạt',
    txt_lix: 'Ngoại tuyến',
    txt_zaix: 'Trực tuyến',
    txt_guz: 'Trục trặc thiết bị',
    txt_yijieb: 'Đã được gỡ bỏ',
    txt_yihuis: 'Tái chế',
    txt_gxsbgj: 'Cập nhật phần mềm thiết bị',
    txt_gxsbgjts: 'Bạn có muốn cập nhật thiết bị không?',
    txt_socketdk: 'Không có kết nối liên lạc với máy chủ, hãy thử lại',
    txt_cscgts: 'Yêu cầu phần mềm cập nhật đã gửi thành công',
    txt_jbsb: 'Tháo thiết bị',
    txt_jbsbts: 'Có chắc là anh muốn tháo thiết bị ra không',
    txt_tscg: 'Hoạt động thành công',
    txt_zdgxgj: 'Tự động cập nhật phần mềm',
    txt_gxgjts: 'Tự động cập nhật',
    txt_beiz: 'Từng dùng',
    txt_qtxbz: 'Xin vui lòng điền vào ghi chú',
    txt_bdsbts: 'Ứng dụng này chỉ được sử dụng cho "tay lốp quốc tế" thiết bị, hãy chắc chắn rằng bạn muốn gắn kết các mô hình thiết bị chính xác',
    txt_qdksb: 'Xin vui lòng mở các thiết bị',
    txt_dksbts1: '1, các thiết bị mới, sau khi khởi động sẽ tự động bắt đầu ràng buộc boot',
    txt_dksbts2: '2, nếu thiết bị bị ràng buộc trước khi các cửa hàng khác, hãy nhấp vào trình đơn thiết lập của thiết bị để tháo trói thiết bị, thiết bị sẽ tự động đi vào hướng dẫn ràng buộc',
    txt_yjdksblw: 'Tôi đã mở thiết bị và kết nối mạng',
    txt_xyb: 'Bước tiếp theo',
    txt_qsclj: 'Vui lòng quét mã QR để kết nối với thiết bị cầm tay接',
    txt_qscts1: 'Thiết bị quét mã thành công sẽ phát ra một tín hiệu "beep"',
    txt_qscts2: 'Và nhắc nhở bạn để quét mã thành công',
    txt_sbtssmcg: 'Thiết bị nhắc nhở mã quét thành công',
    txt_ddsblw: 'Chờ đợi cho các thiết bị mạng',
    txt_zznlbd: '正在努力为您绑定设备',
    txt_qszdd: 'Nó có thể mất hàng chục giây. hãy chờ một chút',
    txt_bdcg: 'Ràng buộc thành công',
    txt_tjcg: 'Thêm thành công',
    txt_tjcgts: 'Xin chúc mừng bạn đã thêm thành công, xin vui lòng điền vào ghi chú tên để giúp bạn nhận dạng thiết bị',
    txt_fhsblb: 'Trở về danh sách các thiết bị',
    txt_jxtjsb: '继续添加设备',
    txt_bzmc: 'Lưu ý tên',


    //检测记录
    txt_sx: 'Chọn lọc',
    txt_khsj: 'Điện thoại khách hàng',
    txt_cphm: 'Biển số',
    txt_cphm1: 'Biển số',
    txt_clxh: 'Mô hình xe hơi',
    txt_xgbz: 'Sửa đổi lưu ý',
    txt_gtfjl: 'Tất cả các hồ sơ',
    txt_jcsj: 'Thời gian phát hiện',
    txt_jcsj1: 'Thời gian phát hiện',
    txt_xzkssj: 'Chọn thời gian để bắt đầu',
    txt_xzjssj: 'Chọn thời gian kết thúc',
    txt_jcjg: 'Kết quả kiểm tra',
    txt_msqk: 'Tình trạng mòn',
    txt_jygh: 'Đề nghị thay thế',
    txt_zysh: 'Lưu ý rằng thiệt hại',
    txt_zcsy: 'Sử dụng bình thường',
    txt_zc: 'Bình thường',
    txt_cz: 'Đặt lại',
    txt_qd: 'Chắc chắn',
    txt_jcjgd: 'Kết quả kiểm tra',
    txt_msqkd: 'Tình trạng mòn',
    txt_sldwd: 'Bốn bánh định vị',
    txt_jyghd: 'Đề nghị thay thế',
    txt_zysh: 'Lưu ý rằng thiệt hại',
    txt_zcsyd: 'Sử dụng bình thường',
    txt_xdwd: 'Vị trí cần thiết',
    txt_xzyd: 'Cần phải chú ý đến',
    txt_zcd: 'Bình thường',
    txt_bgxq: 'Báo cáo chi tiết',
    txt_ljdy: '连接打印',
    txt_fwmd: 'Cửa hàng dịch vụ',
    txt_mddz: 'Địa chỉ cửa hàng',
    txt_jcsb: 'Thiết bị phát hiện',
    txt_ddmd: 'Mục đích của các cửa hàng',
    txt_lic: 'Trên dặm',
    txt_chex: 'Phiên bản',
    txt_jcjyi: 'Phát hiện gợi ý',
    txt_ysbs: 'Màu sắc nhận dạng',
    txt_ztms: 'Toàn bộ mòn',
    txt_hwms: 'Mặc không đều màu',
    txt_dqscjltx: 'Nhắc nhở khoảng cách phanh hiện tại',
    txt_bgxqts: ' 备注：该测试由独立测试中心天津汽车检测中心进行，所用车辆为奥迪品牌FV7203BECGB型乘用车，轮胎规格为：245/40 R18,轮胎充气压力为：前胎230kpa，后胎220kpa；测试场地为：卡达克盐城测试地；所计算的车辆制动距离的速度范围:从100公里/小时减速至0公里/小时。',
    txt_wxsmgz: '微信扫码关注 TyreHub 公众号',
    txt_hwmsjh: 'Vết trầy xước đồng đều',
    txt_zqlun: 'Bánh xe phía trước bên trái',
    txt_zhlun: 'Quay lại trái',
    txt_yqlun: 'Bánh xe phía trước bên phải',
    txt_yhlun: 'Quay lại bên phải',
    txt_pingjunzhi: 'Giá trị trung bình',
    txt_guige: 'Chi tiết',
    txt_gongli: 'kilômét',
    txt_ltwjc: 'Lốp xe không được phát hiện',
    txt_pinpai: 'Thương hiệu',
    txt_ltws: 'Sự xuất hiện của lốp xe',
    txt_sewmts: 'Quét mã qr \n xem báo cáo',
    txt_print: 'Print',





    //店员管理
    txt_xz: 'Điểm mới',
    txt_qy: 'Bật',
    txt_qyz: 'Kích hoạt',
    txt_ty: 'Quy hoạch',
    txt_yhzh: 'Tài khoản người dùng',
    txt_lxfs: 'Thông tin liên lạc',
    txt_cjsj: 'Tạo thời gian',
    txt_bjxx: 'Soạn thảo thông tin',
    txt_xgmm: 'Thay đổi mật khẩu',
    txt_bgzt: 'Trạng thái thay đổi',
    txt_qdytjm: 'Xác định tài khoản {0}{1}?',
    txt_tjdy: 'Thêm thư ký',
    txt_bjdyxx: 'Biên tập thông tin thư ký',
    txt_zhxx: 'Thông tin tài khoản',
    txt_ygxm: 'Nhân viên tên',
    txt_qtxygxm: 'Xin vui lòng điền tên nhân viên',
    txt_lxdh: 'Số liên lạc',
    txt_qtxyglxdh: 'Xin vui lòng điền vào số liên lạc của nhân viên',
    txt_dxyzm: 'Mã xác minh tin nhắn SMS',
    txt_qtxdxyzm: 'Vui lòng điền vào mã xác minh tin nhắn',
    txt_fsdx: 'Gửi tin nhắn',
    txt_tjzh: 'Thêm tài khoản',
    txt_baocun: 'Bảo tồn',
    txt_gtgygzh: 'Tổng số tài khoản nhân viên',



    //登录
    txt_qdytcdlm: 'Chắc chắn bạn muốn thoát khỏi đăng nhập',
    txt_qx: 'Hủy bỏ',
    txt_dl: 'Đăng nhập',
    txt_qsrzh: 'Xin vui lòng nhập ID tài khoản (xin vui lòng nhập số điện thoại di động đăng ký)',
    txt_qsrmm: 'Xin vui lòng nhập mật khẩu',
    txt_zcshzh: 'Đăng ký tài khoản thương mại',
    txt_shzhwjmm: 'Quên passowrd',
    txt_yzdqmm: 'Xác nhận mật khẩu hiện tại',
    txt_szxmm: 'Thiết lập mật khẩu mới',
    txt_xgcg: 'Sửa đổi thành công',
    txt_qtxjmm: 'Xin vui lòng điền vào mật khẩu cũ',
    txt_yzzcsj: 'Xác nhận đăng ký điện thoại di động',
    txt_qtxxmm: 'Xin vui lòng điền vào mật khẩu mới',
    txt_qzctxxmm: 'Xin vui lòng điền vào mật khẩu mới một lần nữa',
    txt_lcmmsrbyz: 'Nhập mật khẩu không phù hợp hai lần',
    txt_gxnxgcg: 'Xin chúc mừng, sửa đổi thành công',
    txt_qljndxmm: 'Hãy nhớ mật khẩu mới của anh',
    txt_fhgrzx: 'Trở về trung tâm cá nhân',
    txt_fsyzm: 'Gửi mã xác minh',
    txt_qtxzcsjh: 'Xin vui lòng điền vào số điện thoại di động đăng ký',
    txt_qtxtxyzm: 'Xin vui lòng điền vào mã xác minh đồ họa',
    txt_qsryzm: 'Hãy nhập captcha',
    txt_qszhhmm: 'Hãy đặt mật khẩu của 6-18 chữ số và chữ cái',
    txt_qzcsrmm: 'Vui lòng lặp lại mật khẩu',
    txt_lcmmbyz: 'Hai mật khẩu không nhất quán',
    txt_hdsy: 'Trang chủ',
    txt_zcshh: 'Số Thương gia đã đăng ký',
    txt_fhdl: 'Quay trở lại đăng nhập',
    txt_wlqqsb: 'Yêu cầu mạng đã thất bại, hãy thử lại',
    txt_wczc: 'Hoàn thành đăng ký',
    txt_wsts: ' Trước khi bắt đầu, hoàn thiện thông tin thương mại của bạn',
    txt_qtxshmc: 'Xin điền tên nhà thương mại',
    txt_shmc: 'Tên thương mại',
    txt_rgszjd: '如公司座机、其他电话、传真等',
    txt_qtlxfs: '其他联系方式',
    txt_kssy: '开始使用',
    txt_Pwear1: '偏磨',
    txt_open: '打开',
    txt_close: '关闭',
    txt_srczhdmm: '输入重置后的密码',
    txt_kcfs: '{0}后可重发',
    txt_xiugai: '修改',
    txt_zzjzsj: '正在加载数据',
    txt_bjshxx: '编辑商户信息',
    txt_chongxinhq: '重新获取',
    txt_gaibangsj: '改绑手机',
    txt_yanzhengjsj: '验证旧手机',
    txt_bangdingxsj: '绑定新手机',
    txt_yhqsyxsjdl: '以后请您使用新手机号登录',



    //登录新
    txt_xzshenfen: '请选择您的身份',
    txt_dlrolewz: '登录{0}号',
    txt_qsrsjh: '请输入手机号',
    txt_zhuce: '注册',
    txt_wanjimima: '忘记密码',
    txt_wanshandzxx: '完善店长号资料',
    txt_qsrxm: '请输入姓名',
    txt_qsrmdm: '请输入门店名',
    txt_qsrmdgddh: '请输入门店固定电话',
    txt_qsrmddz: '请输入门店地址',
    txt_qsrgsdz: '请输入公司地址',
    txt_qsrxxdz: '请输入详细地址',
    txt_tijiaocg: '提交成功',
    txt_qsvbsylwmm: '请设置不少于6位密码',
    txt_zhucerole: '注册{0}号',
    txt_qsrshh: '请输入商户号',
    txt_qsrdzh: '请输入店长号',
    txt_wsshhzl: '完善商户号资料',
    txt_wsdyhzl: '完善店员号资料',
    txt_qsrshm: '请输入商户名(公司名称)',
    txt_qsrshz: '请输入商户主(负责人)',
    txt_qsrzrqy: '请输入责任区域(工作部门)',
    txt_shanghudizhi: '商户地址',
    txt_yhycz: '用户已存在',
    txt_qsrzqdzh: '请输入正确店长号',
    txt_qsrzqshh: '请输入正确商户号',
    txt_xzmdcx: '选择门店查询',



    //门店
    txt_mendianId: '门店ID',
    txt_mendianmc: '门店名称',
    txt_mendiandz: '门店地址',
    txt_mendiandh: '门店电话',
    txt_caozuo: '操作',
    txt_mendiangl: '门店管理',
    txt_gjmendian: '共 {0} 家门店',
    txt_zhengchangyy: '正常营业',
    txt_tingye: '停业',
    txt_gengdxx: '更多信息',
    txt_dianygl: '店员管理',
    txt_biangzt: '变更状态',
    txt_qdygbzhuangtai: '确定要将门店{0}状态变更为{1} 吗？',
    txt_bjmendian: '编辑门店信息',
    txt_xinzenmd: '新增门店',
    txt_qtxmdmc: '请填写门店名称',
    txt_qxzmddz: '请选择门店地址',
    txt_qtxxdz: '请填写详细地址',
    txt_xiangxidz: '详细地址',
    txt_qtxmddh: '请填写门店电话',
    txt_dzxx: '店长信息',
    txt_chaungjianmendian: '创建门店',
    txt_mendianxxxx: '门店详细信息',
    txt_bianji: '编辑',
    txt_mendianzt: '门店状态',

    //商户数据总览
    txt_mendianshuju: '门店数据',
    txt_chakangdxxbb: '查看更多详细报表',
    txt_jczcs: '检测总次数',
    txt_mdpjjc: '门店平均检测',
    txt_jdzcl: '进店总车辆',
    txt_jcl: '检测率',
    txt_msqkjgtj: '磨损情况结果统计（轮胎条数）',
    txt_xyghltjgfb: '需更换轮胎的结果分布',
    txt_xzzyltjgfb: '需注意轮胎的结果分布',
    txt_sldwjgtj: '四轮定位结果统计（轮胎条数）',
    txt_xjxsldwfb: '需进行四轮定位轮胎的结果分布',
    txt_xzzyjxsldwfb: '需注意准备进行四轮定位轮胎的结果分布',
    txt_jrzl: '今日总览',
    txt_xiangqbb: '详情报表',
    txt_xuanzerqckxxsj: '选择日期查看详细数据',
    txt_qxzsjd: '请选择时间段',
    txt_sjdts: '最多只能选择30天以内的时间段',
    txt_zonglan: '总览',
    txt_qushi: '趋势',
    txt_shuliangtj: '数量统计',
    txt_syjcjgz: '所有检测结果中，各种磨损情况的轮胎条数及占比',
    txt_mslttsfb: '磨损轮胎条数分布情况',
    txt_msbgslzb: '(不同条数轮胎磨损的报告数量、以及在总检测数中的占比）',
    txt_sldwjlzb: '所有检测结果中，各种四轮定位结论的轮胎条数及占比',
    txt_sldwfbqk: '四轮定位结论条数分布情况',
    txt_btjgsldwzb: '不同条数四轮定位结论的报告数量、以及在总检测数中的占比',
    txt_jccsqs: '检测次数趋势',
    txt_msqkslqs: '轮胎磨损情况数量趋势',
    txt_jgfbqushi: '磨损轮胎需更换轮胎的结果分布趋势',
    txt_msltjgfbqs: '磨损轮胎需注意轮胎的结果分布趋势',
    txt_ltxsldwslqs: '轮胎需四轮定位情况数量趋势',
    txt_jccs: '检测次数',
    txt_shuliang: '数量',
    txt_zhanbi: '占比',
    txt_chankangd: '查看更多',
    txt_chakanmdxxbb: '查看门店详细报表',


    //国家
    txt_zhongguo: '中国',
    txt_mlxy: '马来西亚',
    txt_yindu: '印度',
    txt_taiguo: '泰国',
    txt_oluosi: '俄罗斯',



    txt_taici: 'TaiCi',
    txt_jianyi: 'Lời khuyên:',
    txt_jianyineirong: 'Tình trạng xay lốp xe, đề nghị kiểm tra thêm',
    txt_jianyineirongzc: 'Bình thường',
    txt_bgtixing: 'Nhắc nhở:',
    txt_bgtuxubfnr: 'Theo tình trạng mòn lốp xe hiện tại, gây ra khoảng cách phanh tăng {0}% (định giá)',
    txt_waishang: 'Thương mềm',
    txt_laohua: 'Lão hóa',
    txt_gubao: 'GuBao',
    txt_xichemeirong: 'Rửa xe và làm đẹp',
    txt_weixiubaoyang: 'Bảo trì',
    txt_guenghuanluntai: 'Thay đổi lốp xe',
    txt_scsltjcy: 'Máy phát hiện lốp cầm tay',
    txt_shijiantishi: 'Thời gian kết thúc phải lớn hơn thời gian bắt đầu',

    txt_qxzclry: 'Hãy chọn người xử lý',
    txt_lf_outworn: 'Bên ngoài của lốp trước trái bị trầy hơn bên trong',
    txt_lf_innerworn: 'Bên trong của lốp trước trái bị trầy hơn bên ngoài',
    txt_lf_bothsideworn: 'Lốp trước bên trái bị trầy xước nặng hơn ở giữa',
    txt_lf_centreworn: 'Lốp trước bên trái bị trầy xước hơn cả hai bên',
    txt_lb_outworn: 'Bên ngoài của lốp trái sau bị trầy hơn bên trong',       
    txt_lb_innerworn: 'Bên trong của lốp sau trái bị trầy hơn bên ngoài',        
    txt_lb_bothsideworn: 'Cả hai bên của lốp trái sau bị trầy xước nặng hơn so với giữa',        
    txt_lb_centreworn: 'Lốp trái phía sau bị trầy hơn hai bên',        
    txt_rb_outworn: 'Bên ngoài của lốp phải bị trầy hơn bên trong',         
    txt_rb_innerworn: 'Bên trong của lốp phải bị trầy hơn bên ngoài',        
    txt_rb_bothsideworn: 'Cả hai bên của lốp phải bị trầy xước nặng hơn so với phần giữa',         
    txt_rb_centreworn: 'Giữa lốp phải bị trầy nhiều hơn cả hai bên',        
    txt_rf_outworn: 'Bên ngoài của lốp trước bên phải bị trầy hơn bên trong',         
    txt_rf_innerworn: 'Bên trong của lốp trước bên phải bị trầy hơn bên ngoài',        
    txt_rf_bothsideworn: 'Cả hai bên của lốp trước bên phải bị trầy xước nặng hơn so với bên giữa',       
    txt_rf_centreworn: 'Lốp trước bên phải bị trầy xước nhiều hơn cả hai bên',  
    txt_tire_need_replace: 'Lốp xe cần phải được thay thế ngay lập tức换',

    txt_alignment_chassis: 'Đề nghị tiến hành thêm 4 bánh định vị hoặc phát hiện khung gầm',

    txt_do_further_check: 'Xin vui lòng kiểm tra thêm',
    txt_uneven_check:'Lốp xe mặc ngoại lệ, khuyến cáo cân bằng và vị trí bốn bánh xe, hệ thống treo kiểm tra',
    txt_tire_rotation: 'Đề nghị thay đổi lốp xe',           
    txt_wear_normal: 'Lốp xe mòn bình thường',   
    'txt_wear_normal;': 'Lốp xe mòn bình thường',     
    txt_tire: 'Lốp xe',
    txt_xiazai: 'Tải về',
    txt_xiazaishibai: 'Tải về thất bại',
    txt_appname: 'Leadshub',
    txt_dianjixiazaiandroid: 'Nhấp vào tải về Android',
    txt_dianjixiazaiios: 'Nhấp chuột vào tải về Ios',






    txt_gelie: 'Biểu hiện',
    txt_diaokuai: 'DiaoKuai',
    txt_chaungci: 'Mũi',
    txt_cashang: 'Khá',
    txt_yichang: 'Bất thường',
    txt_qjybjcltazqk: 'Xin kiểm tra thêm về việc lắp đặt lốp xe',
    txt_wear_overall: 'Toàn bộ mòn',
    txt_pattern_wear: 'Bất thường mòn',
    txt_tire_age: 'Lốp xe năm',
    txt_tire_appearance: 'Sự xuất hiện của lốp xe',
    txt_tire_age_5:'Lốp xe đã được sử dụng hơn 5 năm, đề nghị kiểm tra toàn diện lốp xe, thay thế nếu cần thiết',
    txt_tire_age_8:'Lốp xe đã được sử dụng hơn 8 năm, đề nghị kiểm tra toàn diện lốp xe, thay thế nếu cần thiết',
    txt_tire_age_6:'Lốp xe có hiệu lực hơn 6 năm, hãy kiểm tra thường xuyên',
    txt_tire_age_3:'Lốp xe có hiệu lực hơn 3 năm, hãy kiểm tra thường xuyên',
    txt_tire_age_ok: 'Lốp xe tốt tuổi',
    txt_tire_trauma_check: 'Có chấn thương lốp xe, đề nghị kiểm tra thêm',
    txt_install_abnormal_check: 'Lốp xe chống, xin vui lòng xác nhận xử lý',
    txt_tire_appearance_ok: 'Lốp xe có vẻ tốt',
    txt_ltlcgstm: 'Theo tình trạng mòn lốp xe hiện tại, lốp xe cho dặm (0}km(định giá)',
    'txt_tire_need_replace;': 'Lốp xe cần phải được thay thế ngay lập tức.',
    'txt_uneven_check;': 'Lốp xe mặc ngoại lệ, khuyến cáo cân bằng và vị trí bốn bánh xe, hệ thống treo kiểm tra',
    txt_tire_rotation: 'Đề nghị thay đổi lốp xe',
    'txt_tire_age_ok': 'Lốp xe tốt tuổi',
    'txt_wear_uniform;': 'Một lốp xe mặc đồng đều hơn',    
    txt_wear_uniform: 'Lốp xe mặc đồng đều hơn',    
    'txt_tire_boundary;': 'Tình trạng lốp xe bị mòn',     
    txt_tire_boundary: 'Tình trạng lốp xe bị mòn', 
    txt_plcl: 'Xử lý hàng loạt',
    txt_qbxz: 'QuanXuan',
    txt_scjcjg: 'Kết quả thử nghiệm cuối cùng',
    txt_ltxhlcgs: 'Ước tính số dặm đường dài của lốp xe',
    txt_ltazhuang: 'Lốp xe cài đặt:',
    txt_dqltlctx: 'Lốp xe hiện tại đã đến giới hạn, hãy thay lốp ngay lập tức',
    txt_dottx: 'Ước tính tuổi sử dụng lốp xe',
    txt_danweinian: '(đơn vị: năm)',
    txt_danweikm: '(đơn vị: km)',
    txt_myhqdsj: 'Không nhận được thời gian DOT',
    txt_dotjstx: 'Lốp còn lại khoảng {0} ngày',
    txt_dotjstx2: 'Lốp xe đã hơn 5 năm tuổi, xin vui lòng thay thế ngay lập tức',
    txt_dotsjztx: '(DOT: ngày làm bánh xe)',
    'txt_tire_age_ok;': 'Lốp xe tốt tuổi',


    //微信公众号
    txt_mdmz: 'Tên cửa hàng',
    txt_mddzz: 'Địa chỉ cửa hàng',
    txt_sbid: 'ID thiết bị.',
    txt_jsxm: 'Kỹ thuật viên tên',
    txt_shoujhm: 'Số điện thoại di động',
    txt_dxyzmm: 'Mã xác minh tin nhắn SMS',


    txt_jishimz: 'Thuật viên',
    txt_ltlcgsnew: 'Lốp xe chạy khoảng {0} km',
    txt_ltlcgsnewin: 'Lốp xe chạy khoảng {0} km',
    txt_pinnate_wear: '羽状磨损',
    txt_msjxtx: 'Lốp xe đã đến giới hạn, xin vui lòng thay thế ngay lập tức',
    txt_ltfz: 'Bên trong và bên ngoài chống',
    txt_install_check: 'Cài đặt kiểm tra',
    txt_install_ok: 'Cài đặt bình thường',
    LF: '[Bánh xe phía trước bên trái]',
    RF: '[Bánh xe phía trước bên phải]',
    LB: '[Quay lại trái]',
    RB: '[Quay lại bên phải]',
    FF: '[Trục trước]',
    BB: '[Trục quay sau]',
    txt_appearance_check:'Chấn thương lốp xe, bảo trì để xác nhận',
    txt_uneven_center:'Sự mòn bất thường ở giữa lốp xe, đề nghị kiểm tra áp suất bánh xe',
    txt_uneven_out: 'Ngoại lệ lốp xe mòn bên ngoài, đề nghị kiểm tra vị trí bốn bánh và áp suất lốp',
    txt_pinnate_check: 'Lốp xe có sọc mòn, đề nghị kiểm tra thêm các bộ phận khung xe',
    txt_uneven_inside: 'Mặc ngoại lệ bên trong của lốp xe, đề nghị kiểm tra vị trí bốn bánh xe và áp suất lốp',
    'txt_do_further_check;': 'Xin vui lòng kiểm tra thêm',
    txt_uneven_bothside: 'Mặc dù bất thường trên cả hai bên của lốp xe, đề nghị kiểm tra vị trí bốn bánh và áp suất lốp.',

    txt_msyzljgh: 'Lốp xe bị mòn nghiêm trọng, xin vui lòng thay thế ngay lập tức.',
    txt_serious_trauma_check:"Có một chấn thương nghiêm trọng trên lốp xe, đề nghị thay lốp xe,",
    txt_appearance_lookup:"Hãy kiểm tra lốp xe",
    txt_wear_lookup :"Hãy kiểm tra lốp xe",
    txt_dotscsj: 'Thời gian sản xuất',
    txt_whqdscsj: 'Không có thời gian sản xuất',
    purp_tireservice: 'Dịch vụ lốp xe',
    purp_vehicle_inspection: 'Kiểm tra xe',

    txt_qiao: 'Cây cầu',
    txt_left: 'Bên trái',
    txt_right: 'Bên phải',
    txt_lun: 'Bánh xe',
    txt_huawen: 'Giày brogue',
    txt_taihao: 'Lốp trơn, số',
    txt_taiya: 'Lốp trơn gỗ dán',
    txt_chexlw: 'Mô hình bánh xe',
    txt_jiancerenyuan: 'Phát hiện viên',
    txt_beitai:'Chuẩn bị lốp trơn',
    txt_tuoche:'Khu dân',
    txt_guache:'Trailer',
    txt_chassis_check: 'Khung kiểm tra',
    txt_chassis_ok: 'Khung kiểm tra tốt',
    txt_chassis_oil: 'Rò rỉ bộ giảm xóc, đề nghị để xác nhận, thay thế khi cần thiết.',
    txt_chassis_aging: 'Trục cao su lão hóa, đề nghị thay thế xử lý.',
    txt_chassis_more: 'Xe trục cao su lão hóa và chấn thương rò rỉ ngoại lệ, đề nghị sửa chữa',
    chassis_oil:'Sự rò rỉ của bộ giảm chấn',
    chassis_aging:'Lão hóa cao su trục đầu',
    chassis_normal:'Bình thường',
    
    // new add  wu
    txt_lights:'灯光',
    txt_high_beam:'远光灯',
    txt_low_beam:'近光灯',
    txt_daytime:'日行灯',
    txt_fog_light:'雾灯',
    txt_brake_light:'刹车灯',
    txt_turn_signals:'转向灯',
    txt_backup_lights:'倒车灯',
    txt_hazards:'应急灯',

    txt_glass:'玻璃',
    txt_windshield:'前风挡',
    txt_back_glass:'后玻璃',
    txt_right_side_windows:'右侧玻璃',
    txt_left_side_windows:'左侧玻璃',
    txt_wipers_front:'前雨刷',
    txt_wipers_rear:'后雨刷',

    txt_under_hood:'发动机舱',
    txt_horn:'喇叭',
    txt_oil_level:'油位',
    txt_air_filter:'空滤',
    txt_trans_fluid:'机油',

    txt_coolant_level:'冷却液液位',
    txt_power_steering_fluid:'转向液',
    txt_windshield_washer_fluid:'玻璃水',
    txt_belts:'皮带',
    txt_hoses:'软管',
    txt_ac_system:'空调系统',
    txt_battery:'蓄电池',

    txt_under_vehicle:'底盘',
    txt_suspension:'悬架',
    txt_exhaust:'排气管',
    txt_brake_lines:'制动管路',
    txt_oil_drain_plug:'放油塞',
    txt_differential:'差异',

    txt_brakes:'刹车',
    txt_front_left:'左前',
    txt_front_right:'右前',
    txt_rear_left:'左后',
    txt_rear_right:'右后',
    txt_parking_brake:'驻车',
    txt_spare_pressure:'备胎',
      
    txt_interior:'内部',
    txt_cabin_fiter:'活性炭过滤器',
    txt_heating:'暖气装备',
    txt_AC_system:'空调系统',
    txt_interior_lights:'内部照明',
    txt_front_defrost:'前除霜',
    txt_rear_defrost:'后除霜',

    txt_tire_pressure:'轮胎',
    txt_left_front:'左前轮',
    txt_right_front:'右前轮',
    txt_left_rear:'左后轮',
    txt_right_rear:'右后轮',
    

    
    txt_null:'',
    //cormach
    txt_hood:'发动机舱',
    txt_wash_liquid:'洗涤液',
    txt_level_control:' 液位',
    txt_haoxiaoxi:'正常',
    txt_vedi_Note:'注意 ',
    txt_replace1:'警告',
    txt_radiator_fluid:'防冻液',
    txt_engine_oil:'发动机油',
    txt_brake_fluid:'刹车液',
    txt_quality_control:'品控检查',
    txt_multimeter:'仪表检测',
    txt_subtotal:'小计',
    txt_shock_absorber:'减震器',
    txt_check_loss:' 泄漏检查',
    txt_brake_disc:' 刹车盘',
    txt_wear_condition:'磨损状态',
    txt_brake_pads:'刹车片',

    txt_change_control:'改变控制',
    txt_air_control:'空调系统',
    txt_last_reload:'上一次冷媒补充',
    txt_lighting:'灯光',
    txt_verification1:'雨刮器',
    txt_dynamometer:'扭矩检查',
    txt_batteria:'电池',
    txt_verification:'运转检查',
    txt_levellow:'正常',
    txt_levelmiddle:'工作排程',
    txt_levelhigh:'替换',
    txt_tyrenumber:'扫描深度:',
    txt_cormach_title:'磨损&偏磨',
    txt_wearlow:'花纹磨损均匀',
    txt_wearmiddle:'轻微磨损',
    txt_wearhigh:'严重磨损',
    txt_namtishi:'32度胎面花纹深度',
    txt_zhiliangkongzhi:'质量控制',
    txt_buchongzhengduan:'补充诊断',
    txt_season_summer:'夏季胎',
    txt_season_winter:'冬季胎',
   


    txt_khxm:'Tên khách hàng',
    txt_khyx:'Email khách hàng',
   
    txt_tire_season: 'Tất cả các lốp',
    txt_tire_other: 'Lốp xe khác',
    txt_bolt: 'Bu lông',
    txt_goods_name: 'Tên hàng hóa',
    txt_yes: 'là',
    txt_no: 'Nếu không',  
}


// WEBPACK FOOTER //
// ./src/i18n/viet.js